import classes from './GetAyoba.module.scss';
import { useState, useEffect } from 'react';
import { isAndroid, isMobile } from 'react-device-detect';
import Image from 'next/image';
import GetAyobaCard from '../../organisms/getAyobaCard/GetAyobaCard';

export default function GetAyoba(props) {
    const [deviceType, setDeviceType] = useState(0);
    const [pageLoad, setPageLoad] = useState(false);

    useEffect(() => {
        setPageLoad(true);
        setDeviceType(isAndroid ? 0 : 1);
    }, []);

    if (!props) return null;

    const { hasBackgroundColorBlobs } = props;
    const { site_header } = props[0];
    const { device_store, card_title, overlay_image } = props[1];

    return (
        <div className={classes.oBlockGetAyobaSection}>
            <div className={`container`}>
                <h2
                    className={`${classes.aSectionTitle} ${classes._accent} aSectionTitle _accent fntH2`}
                >
                    {site_header}
                </h2>
                {pageLoad && !isMobile ? (
                    <div className={`${classes.oCardsBlock} row`}>
                        {device_store.map((device, index) => (
                            <GetAyobaCard key={index} device={device} card_title={card_title} />
                        ))}
                    </div>
                ) : (
                    <span className={`${classes.oCardsBlock} row`}>
                        <GetAyobaCard device={device_store[deviceType]} card_title={card_title} />
                    </span>
                )}
            </div>
            {overlay_image?.data?.attributes?.url ? (
                <figure className={classes.aGetAyobaBannerOverlay}>
                    <Image
                        src={overlay_image.data.attributes.url}
                        alt={`get-ayoba`}
                        width={overlay_image.data.attributes.width}
                        height={overlay_image.data.attributes.height}
                        className={classes.aImage}
                        aria-hidden="true"
                        layout="responsive"
                        priority="true"
                    />
                </figure>
            ) : (
                <span></span>
            )}
            {hasBackgroundColorBlobs ? (
                <div className={classes.oBackgroundBlock}>
                    <span className={`${classes.aBgCircle} ${classes.Purple1}`} />
                    <span className={`${classes.aBgCircle} ${classes.Purple2}`} />
                    <span className={`${classes.aBgCircle} ${classes.Red1}`} />
                    <span className={`${classes.aBgCircle} ${classes.Red2}`} />
                    <span className={`${classes.aBgCircle} ${classes.Orange3}`} />
                    <span className={`${classes.aBgCircle} ${classes.Orange4}`} />
                </div>
            ) : (
                <div className={classes.oBackgroundBlock}>
                    <span className={`${classes.aBgCircle} ${classes.Orange1}`} />
                    <span className={`${classes.aBgCircle} ${classes.Orange2}`} />
                </div>
            )}
        </div>
    );
}
